import React from "react";
import { Box, Grid, Hide, Show, Text } from "@chakra-ui/react";
import styles from "./Product.module.css";
import { useState } from "react";
import Navbar from "../navbars/Navbar"
const Routebar = () => {
  
  return (
    <Box  >
     <Navbar />

    </Box>
  );
};

export default Routebar;
